import SchemeChoiceRadioButton from "../SchemeChoice/RadioButton/SchemeChoiceRadioButton";
import { sendToFormIframe } from "../../utils";
import { ELEMENTS, EVENTS, VALIDATION_STATUSES } from "../../constants";

import "../SchemeChoice/RadioButton/SchemeChoiceRadioButtonForm.css";

class SchemeChoiceFormAdapter {
  schemeChoice;
  componentWrapper;
  paymentMethodLogoContainer;

  constructor(env) {
    this.env = env;

    this.componentWrapper = document.getElementById(
      "checkout-frames-scheme-choice-radio-wrapper"
    );
    this.paymentMethodLogoContainer = document.getElementById(
      "payment-method-logo-container"
    );

    this.schemeChoice = new SchemeChoiceRadioButton(this.env, {
      onValueChange: this.onValueChange,
    });
  }

  onValueChange = (preferredScheme) => {
    sendToFormIframe(ELEMENTS.SCHEME_CHOICE, {
      event: EVENTS.VALUE_CHANGED,
      value: preferredScheme,
      validationStatus: VALIDATION_STATUSES.VALID,
      previousValidationStatus: VALIDATION_STATUSES.VALID,
    });
  };

  toggleElementVisibility = (value) => {
    this.schemeChoice.toggleElementVisibility(value);
    this.toggleVisibility(value.isDisplayed);
  };

  toggleVisibility = (isDisplayed) => {
    if (isDisplayed) {
      this.componentWrapper.classList.add("active");
      this.paymentMethodLogoContainer.style.setProperty("display", "none");

      return;
    }

    this.componentWrapper.classList.remove("active");
    this.paymentMethodLogoContainer.style.removeProperty("display");
  };

  getWrapperHeight = () => {
    return this.componentWrapper.getBoundingClientRect().height;
  };
}

export default SchemeChoiceFormAdapter;
